<header class="header">
	<nav class="menu" aria-label="Navegação Principal">
		<div class="menu-container">
			<mat-icon
				class="menu-button"
				svgIcon="porto-bank-icons:menu"
				id="hamburger-menu"
				(click)="openMenu()"
			></mat-icon>
		</div>
	</nav>

	<div class="logo">
		<mat-icon routerLink="/" svgIcon="porto-bank-icons:logo"></mat-icon>
	</div>

	<div class="user">
		@if (client$ | async; as client) {
			<span>Olá, {{ client.firstName }}.</span>
		} @else {
			<button mat-button class="card-button" (click)="redirectCard()">
				<span>Peça seu cartão</span>
			</button>
			<button
				mat-button
				[routerLink]="['/entrar']"
				[queryParams]="{ login: true }"
				class="login-button"
			>
				<span> Login </span>
			</button>
		}
	</div>
</header>

<feature-porto-bank-menu #menu></feature-porto-bank-menu>
